<template>
    <div>
        <v-sheet color="#6f263d" rounded="xl" height="65" dark>
            <v-btn @click="drawer=true" class="mt-3 ml-2" fab color="#000" dark small>
                <v-icon>toc</v-icon>
            </v-btn>
            <v-row class="mt-n10">
                    <v-col cols="10" class="text-center">
                        <div class="ml-10">
                            <strong>{{ modulo }}</strong>
                        </div>
                    </v-col>
                    <v-col cols="2">
                        <v-icon class="mt-n1">person</v-icon>
                        <strong class="ml-2">{{ user }}</strong>
                    </v-col>
                </v-row>
        </v-sheet>

        <component v-bind:is="componente"></component>

        <v-navigation-drawer v-model="drawer" absolute temporary color="#6f263d" dark>
            <v-list-item>
                <v-btn @click="drawer=false" fab color="#000" dark small>
                    <v-icon>arrow_back</v-icon>
                </v-btn>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
            <v-list dense>
                <v-list-item v-for="item in myMenu" :key="item.title" link @click="goMenu(item)">
                <v-list-item-icon>
                    <div v-if="item.title!='Notificaciones'">
                        <v-icon>{{ item.icon }}</v-icon>
                    </div>
                    <div v-else>
                        <div v-if="parseInt(content)!=0">
                            <v-badge color="red" :content="content" overlap>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-badge>
                        </div>
                        <div v-else>
                            <v-icon>{{ item.icon }}</v-icon>
                        </div>
                    </div>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <div class="pa-2">
                    <v-btn @click="goLogin()" block color="#000" dark>
                        Cerrar Sesion
                    </v-btn>
                </div>
            </template>
        </v-navigation-drawer>  
    </div>
</template>
<script>
import Dashboard from "@/components/Dashboard.vue";
import Compras from "@/components/Compras.vue";
import Productos from "@/components/Productos.vue";
import Receta from "@/components/Receta.vue";
import Pedidos from "@/components/Pedidos.vue";
import Inventario from "@/components/Inventario.vue";
import Ajuste from "@/components/Ajuste.vue";
import Usuarios from "@/components/Usuarios.vue";
import Devoluciones from "@/components/Devoluciones.vue";
import Ecommerce from "@/components/Ecommerce.vue";
import Login from "@/components/Acceso.vue";

export default {
  name: 'Acceso',
  components:{Dashboard, Compras, Productos, Receta, Pedidos, Inventario, Ajuste, Usuarios, Ecommerce, Login, Devoluciones},
  data: () => ({
    drawer:false,
    myMenu:[
        {id:1, title:'Dashboard', icon:'home'},
        {id:2, title:'Compras', icon:'shopping_cart'},
        {id:3, title:'Productos', icon:'art_track'},
        {id:4, title:'Receta', icon:'assignment'},
        {id:5, title:'Pedidos', icon:'add_shopping_cart'},
        {id:6, title:'Devoluciones', icon:'remove_shopping_cart'},
        {id:7, title:'Inventario', icon:'iso'},
        {id:8, title:'Ajuste', icon:'compare'},
        {id:9, title:'Usuarios', icon:'account_box'},
        {id:10, title:'Pagos', icon:'monetization_on'},
        {id:11, title:'Ecommerce', icon:'shopping_basket'},
        {id:12, title:'Reportes', icon:'report'},
    ],
    content:0,
    modulo:'DASHBOARD',
    componente:'Dashboard',
    contrato:null,
    user:null,
    apikey:null,

  }),
  async mounted(){
    this.user=localStorage.getItem('user');
    this.apikey=localStorage.getItem('apiKey');
    this.contrato=localStorage.getItem('contrato');
    //console.log(this.user,this.apikey,this.contrato);
    if(this.user!=null && this.apikey!=null && this.contrato!=null){
        this.user=this.user.toUpperCase();
        //accede
    } else {
        this.goLogin()
    }
  },
  methods:{
    goMenu(menu){
        this.modulo=menu.title.toUpperCase();
        this.componente=menu.title;
        this.drawer=false;
    },
    goLogin(){
        localStorage.removeItem('user');
        localStorage.removeItem('apiKey');
        localStorage.removeItem('contrato');
        window.location.href = '/';
    }
  }
}
</script>
